export default "/kiban/_next/static/images/externalsSilk-b9213491c578b457419415c36e71f6aa.png";